// extracted by mini-css-extract-plugin
module.exports = {"code":"shareCard_code__Vcd_X","code_wrapper":"shareCard_code_wrapper__1bMtS"};